<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '1200px' }"
    header="Evento"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="grid">
      <div class="field col-12 md:col-6">
        <label for="responsavel">Responsável</label>
        <AutoComplete
          v-model="obj.responsible.name"
          optionLabel="name"
          optionValue="id"
          placeholder="Selecione o responsável pelo evento"
          dropdown
          :suggestions="responsibles"
          @complete="getResponsibles"
          :class="{
            'p-invalid': submitted && !obj.responsible.name,
          }"
        >
          <template #option="slotProps">
            <div class="flex align-options-center">
              <div>
                <b>Nome: </b>{{ slotProps.option.name }}<br /><b>Email: </b
                >{{ slotProps.option.email }}
              </div>
            </div>
          </template>
        </AutoComplete>
        <small class="p-error" v-if="submitted && !obj.responsible.name"
          >Responsável é obrigatório.</small
        >
      </div>

      <div v-if="!obj.id" class="field col-12 md:col-6"></div>

      <event-form-info :event="obj" :submitted="submitted"> </event-form-info>

      <event-calendar-form :calendarsObj="calendars" :submitted="submitted">
      </event-calendar-form>
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.obj.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Event from "../../../../src/models/internal/event";
import Calendar from "../../../../src/models/internal/calendar";
import Responsible from "../../../models/internal/responsible";

//Services
import EventService from "../../../../src/service/internal/event/event_service";
import ResponsibleService from "../../../../src/service/internal/responsible/responsible_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf, between } from "vuelidate/lib/validators";

//Components
import EventFormInfo from "../../calendar/components/event-form-info.vue";
import EventCalendarForm from "../../calendar/components/event-calendar-form.vue";

export default {
  props: ["eventSelected"],
  components: {
    EventFormInfo,
    EventCalendarForm,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      obj: null,
      event: null,
      calendars: [new Calendar()],
      events: [],
      responsibles: [],
      responsibleSelected: {},
      submitted: false,
      eventService: new EventService(),
      responsibleService: new ResponsibleService(),
      ativos: true,
    };
  },
  validations() {
    let obj = new Event().validations();
    obj.nparticipants = {
      required,
      between(value) {
        return between(this.obj.local.capMin, this.obj.local.capMax)(value);
      },
    };
    obj.pae = {
      required: requiredIf(() => this.event.local.name === "AUDITÓRIO"),
    };
    obj.observation = {
      required: requiredIf(() => this.obj.status === "CANCELED"),
    };
    return {
      obj,
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.event.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.event.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;

      this.event = { ...this.obj };
      this.event.calendars = this.calendars;

      const { responsible } = this.obj;

      if (responsible) {
        let newResponsible;

        if (responsible.id) {
          newResponsible = new Responsible({ ...responsible });
        } else if (responsible.name) {
          newResponsible = new Responsible(responsible.name);
        }

        this.event.responsible = newResponsible.toJson();
      }
      //TODO: ADICIONADO PARA MINIZAR O PROBLEMA, MAS NÃO RESOLVE A QUESTÃO DO VUELIDATE NÃO ESTAR ATRELADO AO CALENDÁRIO, REVISAR ISSO DEPOIS
      if (isFormValid && this.event.calendars.length === 0) {
        this.$msgInfo("Selecione ao menos um período.");
        return;
      }

      if (isFormValid) {
        if (this.event.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      this.eventService
        .create(this.event)
        .then((data) => {
          if (data.status === 201) {
            this.$msgSuccess(data);
            //this.confirmarAgendamento(data.data);
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      this.eventService
        .update(this.event)
        .then((data) => {
          if (data.status === 200) {
            this.$msgSuccess(data);
            // if (data.data.status == "REQUESTED") {
            //   this.confirmarAgendamento(data.data);
            // }
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    //funcionalidade temporariamente desativada
    // confirmarAgendamento(obj) {
    //   this.eventService
    //     .sendEventToEmail(obj)
    //     .then((data) => {
    //       if (data.status === 200) {
    //         this.$toast.add({
    //           severity: "success",
    //           summary: "Mensagem!",
    //           detail:
    //             "Uma notificação de email foi enviada para o CTIS, informando que seu evento foi solicitado.",
    //           life: 10000,
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       this.$msgErro(error);
    //     });
    // },
    hideDialog() {
      this.event = null;
      this.obj = null;
      this.calendars = [new Calendar()];
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
      this.$store.state.views.event.editionMode = false;
    },
    getData() {
      this.obj = this.eventSelected;
      this.calendars = []; //padrão somente um
      if (this.obj.id) {
        this.calendars = this.obj.calendars;
      }
    },
    getResponsibles() {
      this.responsibleSelected.name =
        this.obj.responsible.name === null ? "" : this.obj.responsible.name;
      this.responsibleService
        .findAllResponsible(this.responsibleSelected)
        .then((data) => {
          this.responsibles = data.content;
        });
    },
  },
};
</script>
<style scoped></style>
